var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['calc-price', ( _obj = {}, _obj[("calc-price--size-" + _vm.size)] = _vm.size, _obj )]},[_vm._v(" "+_vm._s(_vm.priceDisplay(_vm.num, _vm.$hideChange(_vm.currency.code)))),_c('currency',{staticClass:"calc-price__currency",attrs:{"measure":_vm.maesure,"size":_vm.size,"symbol":_vm.currency.symbol}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }